var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{
    'platform-android': _vm.isAndroid,
    'platform-ios': _vm.isIOS,
    'is-app': _vm.isApp,
    'is-ios-full': _vm.isIPhoneFullScreen,
    'is-ios-11-1-2': _vm.isIOS_11_1_2,
  },attrs:{"id":"app"}},[_c('ActionSheet'),_c('keep-alive',[(_vm.$route.meta.keepAlive)?_c('router-view'):_vm._e()],1),(!_vm.$route.meta.keepAlive)?_c('router-view'):_vm._e()],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9a22d792","hasScoped":false,"optionsId":"0","buble":{"objectAssign":"Object.assign","transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!../src/App.vue
// module id = 315
// module chunks = 7